import { isUrl } from '../../utils/utils';
import { getAuthorityUserInfo } from '../../utils/authority';

export let menuData = [
  {
    name: '系统管理',
    icon: 'contacts',
    path: 'system',
    children: [
      {
        name: '用户管理',
        path: 'userManagement',
        code: '01.081.001',
      },
      {
        name: '角色管理',
        path: 'roleManagement',
        code: '01.082.001',
        child: [
          {
            name: '新增角色',
            path: 'add',
          },
          {
            name: '编辑角色',
            path: 'edit',
          },
        ],
      },
      {
        name: '人员信息',
        path: 'personManager',
        code: '01.041.001',
      },
      {
        name: '黑名单管理',
        path: 'phoneBlackListSetting',
        code: '01.078.001',
      },
      {
        name: '商行异常操作查询',
        path: 'abnormalOperation',
        code: '01.053.001',
      },
      {
        name: '系统公告管理',
        path: 'systemNotice',
        code: '01.067.001',
      },
      {
        name: '数据导出',
        path: 'dataExport',
        code: '01.068.050',
      },
      {
        name: '验证码查询',
        path: 'smsCode',
        code: '01.072.001',
      },
      {
        name: '短信运营商',
        path: 'smsOperator',
        code: '01.073.001',
      },
      {
        name: '大模型管理',
        path: 'largeModelManagement',
        code: '01.074.001',
      },
      {
        name: '大模型词库管理',
        path: 'productCorrectionDict',
        code: '01.080.001',
      },
      {
        name: '快速开单识别日志',
        path: 'largeModelLog',
        code: '01.083.001',
      },
    ],
  },
  {
    name: '商行管理',
    icon: 'pay-circle-o',
    path: 'booth',
    children: [
      {
        name: '商行管理',
        path: 'stallManager', //'stallManager',
        code: '01.003.001', //01.003.006是转换权限的用户
        child: [
          {
            name: '商行详情',
            path: 'stallManagementDetail',
            child: [
              {
                name: '配货单针式打印模板',
                path: 'stallDotMatrixDistributionEdit',
              },
              {
                name: '销售单针式打印模板',
                path: 'stallDotMatrixSalesTemplateEdit',
              },
              {
                name: '码单模板',
                path: 'stallThermalPrinterMemoEdit',
              },
              {
                name: '销售单模板',
                path: 'stallThermalPrinterOrderEdit',
              },
            ],
          },
        ],
      },
      {
        name: '合同管理',
        path: 'contractManagement',
        code: '01.029.001',
      },
      {
        name: '设备管理',
        path: 'newDeviceManagement',
        code: '01.030.001',
      },
      {
        name: '会员管理',
        path: 'memberManagement',
        code: '01.031.001',
      },
      {
        name: '会员服务管理',
        path: 'memberServicesManagement',
        code: '01.032.001',
      },
      {
        name: '集团管理',
        path: 'orgManagement',
        code: '01.005.001',
      },
      {
        name: '档口分组配置',
        path: 'boothAllGroup',
        code: '01.006.001',
      },
      {
        name: '系统配置',
        path: 'sysConfig',
        code: '01.007.001',
      },
      {
        name: '白名单查询',
        path: 'WhiteList',
        code: '01.008.001',
      },
      {
        name: '语音包激活码管理',
        path: 'voiceCDKEY',
        code: '01.037.001',
      },
      {
        name: '签字撤销',
        path: 'cancelSign',
        code: '01.055.004',
      },
      {
        name: '增值服务管理',
        path: 'addService',
        code: '01.061.001',
      },
      {
        name: '广告管理',
        path: 'advertisingManagement',
        code: '01.063.001',
      },
      {
        name: '标签模板管理',
        path: 'labelTemplateManagement',
        code: '01.069.001',
      },
    ],
  },
  {
    name: '计算配置',
    icon: 'contacts',
    path: 'count',
    children: [
      {
        name: '货款计算',
        path: 'paymentcalculation',
        code: '01.009.001',
      },
      {
        name: '配置分组',
        path: 'configGroup',
        code: '01.013.001',
      },
      {
        name: '配置列表',
        path: 'configlist',
        code: '01.015.001',
      },
    ],
  },
  {
    name: '数据统计',
    icon: 'contacts',
    path: 'statics',
    children: [
      {
        name: '数据统计',
        path: 'statistics',
        code: '01.019.001',
      },
      {
        name: '商行健康度',
        path: 'stallHealth',
        code: '01.077.001',
        child: [
          {
            name: '详情',
            path: 'detail',
          },
        ],
      },
      {
        name: '商行单据统计',
        path: 'billStatistics',
        code: '01.023.001', // 新添加
      },
      {
        name: '商行使用数据',
        path: 'dataAnalysis',
        // code: '01.023.001',  // 新添加
        code: '01.045.001', // 新添加
      },
      {
        name: '在线还款流水表',
        path: 'remotePayAnalysis',
        code: '01.051.001', // 新添加
      },
      {
        name: '官网用户收集',
        path: 'caixmPhone',
        code: '01.034.001', // 新添加
      },
      {
        name: '销售人员管理',
        path: 'salesManagement',
        code: '01.036.001', // 新添加
      },
      {
        name: '每日新增统计',
        path: 'dailyAddStall',
        code: '01.038.001', // 新添加
      },
      {
        name: '每日交易统计',
        path: 'dailyBusinessStall',
        code: '01.039.001', // 新添加
      },
      {
        name: '市场统计数据',
        path: 'marketStallStatistic',
        code: '01.048.001', // 新添加
      },
      {
        name: '商行活跃信息',
        path: 'stallActiveInfo',
        code: '01.049.001', // 新添加
      },
      {
        name: '催收服务统计汇总信息',
        path: 'bankPayment',
        code: '01.052.001',
        // code: '01.002.001',  // todo
      },
      {
        name: '催收服务还款明细信息',
        path: 'bankPaymentDetail',
        code: '01.052.001',
        // code: '01.002.001',  // todo
      },
      {
        name: '增值服务订单',
        path: 'serveOrder',
        code: '01.062.001',
      },
      {
        name: '新签交付统计表',
        path: 'newSign',
        code: '01.065.001',
      },
    ],
  },
  {
    name: '版本管理',
    icon: 'contacts',
    path: 'version',
    children: [
      {
        name: '版本管理',
        path: 'versionmanagement',
        code: '01.020.001',
      },
    ],
  },
  {
    name: '市场列表',
    icon: 'contacts',
    path: 'marketList',
    children: [
      {
        name: '市场列表',
        path: 'marketList', //'marketList',
        code: '01.022.001',
      },
    ],
  },
  {
    name: '商品库管理',
    icon: 'contacts',
    path: 'commodityManage',
    children: [
      {
        name: '商品基础库',
        path: 'commodityBase',
        code: '01.027.001',
      },
      {
        name: '未关联货品表',
        path: 'unassociatedGoods',
        code: '01.028.001',
      },
    ],
  },
  {
    name: '货品基库管理',
    icon: 'contacts',
    path: 'commodityManage2.0',
    children: [
      {
        name: '商品基础库',
        path: 'commodityBase',
        code: '01.027.001',
      },
      {
        name: '商品分类管理',
        path: 'commodityCategory',
        code: '01.027.001',
      },
    ],
  },
  {
    name: '数据服务管理',
    icon: 'contacts',
    path: 'data-service',
    children: [
      {
        name: '数据服务商品库管理',
        path: 'goodsLibrary',
        code: '01.046.001',
      },
      {
        name: '未关联货品表',
        path: 'unconnectedGoods',
        code: '01.047.001',
      },
      {
        name: '数据服务基库货品',
        path: 'goodsSale',
        code: '01.050.001',
      },
    ],
  },
  {
    name: '任务管理',
    icon: 'contacts',
    path: 'task-management',
    children: [
      {
        name: '定时任务管理',
        path: 'timedTask',
        code: '01.070.001',
      },
      {
        name: '定时任务日志',
        path: 'timedTaskLog',
        code: '01.071.001',
      },
    ],
  },
  {
    name: '设置',
    icon: 'setting',
    path: 'setting',
    children: [
      {
        name: '健康度权重设置',
        path: 'healthWeightSetting',
        code: '01.076.001',
      },
      {
        name: '人员-市场设置',
        path: 'csmAreaSetting',
        code: '01.075.001',
      },
      {
        name: '催收规则配置',
        path: 'delegationCollectionRuleSetting',
        code: '01.079.001',
      },
    ],
  },
];

function formatter(data, parentPath = '/', parentAuthority) {
  return data.map((item) => {
    let { path } = item;
    if (!isUrl(path)) {
      path = parentPath + item.path;
    }
    const result = {
      ...item,
      path,
      authority: item.authority || parentAuthority,
    };
    if (item.children) {
      result.children = formatter(item.children, `${parentPath}${item.path}/`, item.authority);
    }
    return result;
  });
}

export const getMenuData = () =>
  formatter(
    (function (menuData) {
      const userInfo = getAuthorityUserInfo();
      if (userInfo != null) {
        const userRoles = userInfo.permissionCodes || [];
        menuData.forEach((item, index) => {
          item.children = item.children.filter((v) => {
            return userRoles.includes(v.code);
          });
        });
        menuData = menuData.filter((v) => {
          return v.children.length > 0;
        });
      }
      return menuData;
    })(menuData),
  );
